import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Log-index-1992f2b898d2409dc-1'),
    routerUrl: '/Log',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Log')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Log-index-1992f2b898d2409dc-2'),
        routerUrl: '/LogForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./LogForm')),
      },
      //$MORE$
    ],
  },
];
